<div
  *ngIf="validTimes | async as validTimes"
  data-cy="inventory-past-purchases-section"
  class="inventory-past-purchases"
  [class.desktop-tablet]="
    platform === PlatformEnum.desktop || platform === PlatformEnum.tablet
  "
>
  <ion-list class="inventory-past-purchases-list">
    <ion-radio-group
      [(ngModel)]="pastPurchaseDays"
      (ionChange)="onPastPurchaseDaysChange()"
    >
      <ion-item
        *ngFor="
          let inventoryOptionDetails of selectedCreateInventoryOption?.subCategoryDetails;
          let i = index
        "
        [attr.data-cy]="
          'inventory-past-purchase-' + inventoryOptionDetails.displayText
        "
        class="inventory-past-purchase-item"
      >
        <ion-radio
          aria-labelledby="past-purchase-days"
          [attr.data-cy]="
            'inventory-past-purchase-' +
            inventoryOptionDetails.displayText +
            '-radio-button'
          "
          mode="ios"
          slot="end"
          justify="space-between"
          labelPlacement="start"
          [attr.data-cy]="
            'inventory-past-purchase-' +
            inventoryOptionDetails.displayText +
            '-text'
          "
          value="{{ inventoryOptionDetails?.pastPurchaseDays }}"
          [disabled]="!validTimes[i]"
          >{{ inventoryOptionDetails?.displayText | titlecase }}</ion-radio
        >
      </ion-item>
    </ion-radio-group>
  </ion-list>
</div>
